import React, { createContext } from "react";
import Pool from './login-pool';
import { AuthenticationDetails, CognitoUser } from "amazon-cognito-identity-js";

// This has been created so that user validates his credentials again for particular use cases(like change password)
const AccountContext = createContext();

// This has been created to get the current session of the user.
const Account = (props) => {
    const getSession = async () => 
        await new Promise((resolve, reject) => {
            const user = Pool.getCurrentUser();
            if(user) {
                user.getSession(async (err, session) => {
                    if(err) {
                        console.log('Account getSession: ', err);
                        // Logout the user if not able to retrieve/create a valid session
                        if(user) {
                            user.signOut();
                            window.location.reload();
                        }
                        reject();
                    } else {
                        const attributes = await new Promise((resolve, reject) => {
                            user.getUserAttributes((err, attributes) => {
                                // console.log('account21', attributes);
                                if(err) {
                                    console.log('Account 23', err);
                                    reject();
                                } else {
                                    let results = {};
                                    for(let attribute of attributes) {
                                        // console.log('att', attribute);
                                        const {Name, Value} = attribute;
                                        results[Name] = Value;
                                    }

                                    resolve(results);
                                }
                            })
                        })
                        const token = session.getIdToken().getJwtToken();

                        resolve({
                            user,
                            headers: {
                                Authorization: token,
                            },
                            ...session,
                            ...attributes,
                        });
                    }
                });
            } else {
                reject();
            }
        })

    // basic authentication feature calling CognitoUser with username,password and pool
    const authenticate = async (Username, Password) => 
        await new Promise((resolve, reject) => {
            const user = new CognitoUser({Username, Pool});
            const authDetails = new AuthenticationDetails({Username, Password});

            user.authenticateUser(authDetails, {
                onSuccess: (data) => resolve(data),
                onFailure: (err) => {
                    console.error('onFailure', err);
                    reject(err);
                },
                newPasswordRequired: (data) => {
                    console.log('new password required!');
                    resolve(data);
                },
            })
        })
    
    const logout = () => {
        const user = Pool.getCurrentUser();
        if(user) {
            user.signOut();
            window.location.reload();
        }
    }

    const forgotPassword = async (Username, charityId) => {
        await new Promise((resolve, reject) => {
            const user = new CognitoUser({Username, Pool});
            const ClientMetaData = { "charityId" : String(charityId) }
            user.forgotPassword({
                onSuccess: (data) => resolve(data),
                onFailure: (err) => reject(err),
            }, ClientMetaData)
        })
    }

    const changePassword = async(Username, oldPassword, newPassword) => {
        await new Promise((resolve, reject) => {
            const user = new CognitoUser({Username, Pool});
            user.changePassword(oldPassword, newPassword, {
                onSuccess: (data) => resolve(data),
                onFailure: (err) => {
                    console.error('onFailure', err);
                    reject(err);
                }
            })
        })
    }

    return (
        <AccountContext.Provider 
            value={{
                forgotPassword,
                logout,
                getSession,
                authenticate,
                changePassword,
            }}
        >
            {props.children}
        </AccountContext.Provider>
    )
}

export { Account, AccountContext };

